module.exports = __webpack_public_path__ + "static/img/1_1_1.b417e7c0.jpg";